const user = {
  en: {
    avatar: "Avatar",
    name: "Name",
    email: "E-mail",
    phone: "Phone",
    status: "Status",
    viewUser: "View User"
  },
  pt: {
    avatar: "Avatar",
    name: "Nome",
    email: "Email",
    phone: "Telefone",
    status: "Status",
    viewUser: "Visualizar"
  },
  es: {
    avatar: "Avatar",
    name: "Nombre",
    email: "Correo electrónico",
    phone: "Teléfono",
    status: "Estado",
    viewUser: "Ver Usuario"
  }
}

export default user
